import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  fleetDisclaimer: {
    color: theme.palette.warning.main,
    textAlign: 'justify',
    display: 'block',
    marginBottom: '1rem',
  },
  warningIcon: {
    fontSize: '1rem',
    verticalAlign: 'text-bottom',
    marginRight: '0.5rem',
  },
  container: {
    minWidth: '100%',
    margin: 0,
  },
  root: {
    boxShadow: '0px 3px 6px #0000001A',
    display: 'flex',
    flexWrap: 'nowrap',
    width: '100%',
    margin: '0 auto',
    padding: 0,
    '& > *': {
      margin: theme.spacing(1),
      width: '100%',
      height: '100%',
    },
  },
  formRowItem: {
    paddingTop: '13px !important',
    paddingBottom: '8px !important',
  },
  formRowLastItems: {
    paddingTop: '10px !important',
    paddingBottom: '10px !important',
  },
  grid: {
    display: 'flex',
    justifyContent: 'space-around',
    flexWrap: 'nowrap',
    padding: 0,
    margin: 0,
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
    },
  },
  formParentContainer: {
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      minWidth: '100%',
    },
  },
  formContainer: {
    minWidth: '100%',
    padding: '30px 25px',
  },
  mapContainer: {
    height: '100%',
    width: '100%',
    padding: 15,
  },
  marginRight: {
    marginRight: theme.spacing(2),
  },
  formHeader: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    padding: '14px 33px 11px',
    fontSize: '16px',
    width: '100%',
    flexWrap: 'wrap',
    minHeight: 66,
  },
  formHeaderLabel: {
    width: '100%',
  },
  formHeaderLabelTitle: {
    marginBottom: 0,
    fontSize: 16,
  },
  formHeaderLabelSubtitleTitle: {
    marginBottom: 0,
    fontSize: 11,
  },
}));

export default useStyles;
